import { useMemo } from 'react'
import { useSearchParams } from 'react-router'

export const useIdCompany = () => {
  const [searchParams] = useSearchParams()
  return useMemo(
    () => ({ idCompany: searchParams.get('idCompany') ?? '' }),
    [searchParams]
  )
}
